// import { firePixelsByLocation } from '../Utils/utils';

const placeAnuraScript = () => {
//   const scriptString = `
// <script type="text/javascript">
//   (function(){
//       var anura = document.createElement('script');
//       if ('object' === typeof anura) {
//           var request = {
//               instance: 895403957,
//               source: '${localStorage.getItem('affidASR') || 'test'}',
//               campaign: 'auto',
//               // exid: 'optionalSingleUseExternalId',
//               // additional: 'optionalAdditionalData',
//               // variable: 'optionalResponseObjectVariable',
//               callback: 'callbackAnura',
//           };
//           var params = [];
//           for (var x in request) params.push(x+'='+encodeURIComponent(request[x]));
//           params.push(Math.floor(1E12*Math.random()+1));
//           anura.type = 'text/javascript';
//           anura.async = true;
//           anura.src = 'https://script.anura.io/request.js?'+params.join('&');
//           var script = document.getElementsByTagName('script')[0];
//           script.parentNode.insertBefore(anura, script);
//       }
//   })();
// </script>
// `;
//   firePixelsByLocation([btoa(scriptString)], 'head', '', {});
};

export default placeAnuraScript;
